import { Link } from "gatsby";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LOGGEDIN } from "../../../constants/auth";
import {
  AddItemToCart,
  CreateCart,
  CreateCartWithCustomer,
} from "../../../lib/dynamicQueries/cart";
import { updateCart } from "../../../slices/cart";
import { removeFromFavorites } from "../../../slices/wishlist";
import { getError } from "../../../utils/errorCodes";

const WishlistContent = ({ toggle }) => {
  const { favorites } = useSelector((state) => state.wishlist);
  const { authState, user } = useSelector((state) => state.auth);
  const { cartId, items } = useSelector((state) => state.cart);
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  function handleRemoveFromWishlist(e, id) {
    e.preventDefault();
    dispatch(removeFromFavorites(id));
  }

  async function handleAddToCart(e, product) {
    e.preventDefault();
    if (authState === LOGGEDIN) {
      if (cartId) {
        const response = await AddItemToCart(cartId, {
          id: product.variant.shopifyId,
          quantity: 1,
        });
        if (response.cart) {
          dispatch(updateCart(response.cart));
        } else {
          const err = getError(response.customerUserErrors?.[0].code);
          setError(err);
        }
      } else {
        const response = await CreateCartWithCustomer(
          {
            id: product.variant.shopifyId,
            quantity: 1,
          },
          user
        );
        if (response.cart) {
          dispatch(updateCart(response.cart));
        } else {
          const err = getError(response.customerUserErrors?.[0].code);
          setError(err);
        }
      }
    } else {
      if (cartId) {
        const response = await AddItemToCart(cartId, {
          id: product.variant.shopifyId,
          quantity: 1,
        });
        if (response.cart) {
          dispatch(updateCart(response.cart));
        } else {
          const err = getError(response.customerUserErrors?.[0].code);
          setError(err);
        }
      } else {
        const response = await CreateCart({
          id: product.variant.shopifyId,
          quantity: 1,
        });
        if (response.cart) {
          dispatch(updateCart(response.cart));
        } else {
          const err = getError(response.customerUserErrors?.[0].code);
          setError(err);
        }
      }
    }
  }

  return (
    <div className="w-full flex flex-col grow overflow-hidden">
      <div className="max-w-[900px] w-full mx-auto px-5 flex flex-wrap justify-start">
        {favorites.length === 0 && (
          <div className="w-full flex flex-col items-center justify-center py-[50px]">
            <h1 className="text-lg font-semibold my-[25px] text-gray-500">
              Love It? Add To My Wishlist
            </h1>
            <p className="text-center max-w-[650px] mx-auto text-sm font-medium text-[#828282]">
              My Wishlist allows you to keep track of all of your favorites and
              shopping activity whether you're on your computer, phone, or
              tablet. You won't have to waste time searching all over again for
              that item you loved on your phone the other day - it's all here in
              one place!
            </p>
            <button
              className="my-[25px] py-[13px] px-[30px] bg-[#434655] text-white text-sm font-bold"
              onClick={toggle}
            >
              Continue Shopping
            </button>
          </div>
        )}

        {/* Card */}
        {favorites.map((product, index) => (
          <Link
            key={index}
            to={`/products/${product.handle}?variant=${product.variant.id}`}
            className="relative flex flex-col justify-between cursor-pointer w-[48%] lg:w-[22%] mr-[4%] mb-[4%]
          bg-white no-underline"
          >
            {/* Delete Button */}
            <button
              className="absolute top-2 right-2 w-[25px] h-[25px] flex items-center justify-center z-10"
              onClick={(e) => handleRemoveFromWishlist(e, product.id)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                className="h-[25px] object-contain"
              >
                <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
              </svg>
            </button>
            {/* Image */}
            <div className="block -order-2 h-[180px]">
              <img
                src={
                  product.variant.image?.originalSrc ||
                  product.image?.originalSrc
                }
                alt={product.variant.image?.altText || product.title}
                className="max-w-full w-full h-full object-cover object-top"
              />
            </div>
            {/* Add to cart Button */}
            <button
              className="relative z-[3] text-sm font-bold text-center uppercase p-[6px] block bg-black text-white"
              onClick={(e) => handleAddToCart(e, product)}
              disabled={items.find(
                (item) => item.merchandise.id === product.id
              )}
            >
              {items.find((item) => item.merchandise.id === product.id)
                ? "Added to cart"
                : "Add to cart"}
            </button>
            {/* Name */}
            <button className="w-auto z-auto cursor-pointer text-left">
              <span className="text-black font-bold mt-3 mb-[6px] text-ellipsis whitespace-normal">
                {product.title}
              </span>
            </button>
            {/* Variants */}
            <div className="text-sm leading-[16px] text-[#333] mb-[10px] whitespace-nowrap">
              {product.variant.title}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default WishlistContent;
